import React from 'react';
import util from "../../util/tools";
import Toast from '../common/Toast'
import './index.css';
import Header from "../common/Header";

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.timer=null
        this.state = {
            size:200,
            value:'',
            phone:'',
            showToast:false,
            toastText:'',
            imgUrl:'',
            wechatName:'',
            QQ:'',
            phone1: ''
        };

        this.showText = this.showText.bind(this);
    }

    componentDidMount() {
        document.title = '意见反馈';
        this.wechatInfo()
    }

    componentWillUnmount(){
        clearTimeout(this.timer)
    }

    changeText(e){
        let size = e.target.value.length;
        if(size<=200){
            this.setState({
                value: e.target.value,
                size:200-size
            })
        }
    }

    wechatInfo(){
        util.ajax({
            url: "/zh/wechat/info",
            isUser: true,
            isWechatId: true,
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data
                    this.setState({
                        imgUrl:data.qrcode_url,
                        wechatName:data.commontitle,
                        QQ:data.qq,
                        phone1: data.tel
                    })
                }
            }
        });
    }

    savePhone(e){
        if(e.target.value.length<12){
            this.setState({
                phone: e.target.value
            })
        }
    }

    showText(text,callback){
        this.setState({
            showToast : true,
            toastText: text
        },()=>{
            setTimeout(()=>{
                this.setState({
                    showToast: false
                },()=>{
                    if(!!callback){
                        callback();
                    }
                })
            },2000);
        })
    }

    submit(){
        let value = this.state.value;
        let phone = this.state.phone;
        let that = this
        let reg = /^1\d{10}$/
        if(value.length <= 0){
            this.showText('请输入提交内容！');
            return false;
        }
        if(!!phone && !reg.test(phone)){
            this.showText('手机格式不符合！');
            return false;
        }

        util.ajax({
            url: "/zh/wrong/suggestion",
            method:'post',
            isUser: true,
            data: {
                'wrong_content':value,
                'tel':phone
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    this.setState({
                        value:'',
                        phone:'',
                    },()=>{
                        this.showText('提交成功！',()=>{
                            that.props.history.push('/')
                        });
                    })
                }else {
                    this.showText(res.result.status.msg);
                }
            }
        });
    }

    render() {
        return (
            <div className='feedback'>
                <Header />
                <div className='feedback_inpBox'>
                    <textarea onChange={(e)=>this.changeText(e)} value={this.state.value} placeholder='请输入您的反馈意见' className='feedback_inpBox_textarea' name="" id="" cols="30" maxLength={200}
                              rows="10"></textarea>
                    <div style={{textAlign:'right',paddingRight:'0.3rem'}}><span className='feedback_inpBox_fontNum'>剩余{this.state.size}字</span></div>
                </div>
                <p className='feedback_tel'>请留下您的联系方式，方便回访：</p>
                <div className='feedback_inpBox1'>
                    <input placeholder='请填写您的手机号（选填）' value={this.state.phone} onChange={(e)=>this.savePhone(e)} className='feedback_inpBox1_inp' type="number" maxLength='11'/>
                </div>
                <button className='feedback_btn' onClick={()=>this.submit()}>提交反馈</button>
                <div className='feedback_series'>
                    <div className='feedback_series_l'>
                        <span className='feedback_series_l_single'>客服 QQ：{this.state.QQ}</span>
                        <span className='feedback_series_l_single'>客服电话：{this.state.phone1}</span>
                        <span className='feedback_series_l_single'>工作时间：9:00-18:00</span>
                        <span className='feedback_series_l_single'>微信公众号：{this.state.wechatName}</span>
                    </div>
                    <div className='feedback_series_r'>
                        <img className='feedback_series_r_erCode' style={{width:'100%'}}
                             src={this.state.imgUrl} />
                        <span>长按关注二维码</span>
                    </div>
                </div>

                <Toast text={this.state.toastText}/>
            </div>
        );
    }
}